import Modal from 'react-modal';
import { createDynamicLink } from '../../utils/dynamicLinks';
import "./Download-popup.scss"
import { useParams } from 'react-router-dom';

// This line is necessary for accessibility reasons. Replace #root with your app element id
Modal.setAppElement('#root');

const DownloadPopup = ({ modalIsOpen, closeModal }: any) => {

    const { userId } = useParams();
    
    const onDownloadClick = async () => {
        
        if (userId) {
            let sl = await createDynamicLink(userId)
            window.location.href = sl;
        }
    }
    const customStyles = {
        content: {
            top: 'auto',
            left: '50%',
            right: 'auto',
            bottom: '0%',
            marginRight: '-50%',
            transform: 'translate3d(-50%, 0, 0)',
            opacity: 1,
            transition: 'all 0.6s ease',
            animation: 'slideIn 0.6s ease-out forwards',
            borderRadius: '12px 12px 0px 0px',
            padding: '15px'
        },
        overlay: {
            backgroundColor: 'rgba(0,0,0,0.5)',
            zIndex: 10001
        }

    };

    return (
        <Modal
            isOpen={modalIsOpen}
            onRequestClose={closeModal}
            style={customStyles}
        >
            <img
                src={"https://d1vwbtncdsw8o3.cloudfront.net/invite-images/pangeaIcon2.png"}
                alt="Logo"
                style={{ height: '80px', width: '80px', display: 'flex', alignSelf: 'center', margin: 'auto', marginBottom: '15px', marginTop: '10px', borderRadius: "12px" }}
            />
            <div className="Popup">
                <p className="Popup-description">Travel is more fun with friends.</p>
                <p className="Popup-description">Download the app today.</p>
                <ul className="Popup-list">
                    <li className="Popup-list-item">📍  Track cities and countries you've been</li>
                    <li className="Popup-list-item">✈️  Coordinate travel plans with friends</li>
                    <li className="Popup-list-item">⭐️  Get and share recommendations</li>
                    <li className="Popup-list-item">😎  Meet other travelers</li>
                </ul>

                <div className="Action-button-container">
                    <button className="Action-button" onClick={onDownloadClick}>Download The App</button>
                    <button className="Action-button Close" onClick={closeModal}>Close</button>
                </div>
            </div>
        </Modal>
    );

};

export default DownloadPopup;
